/*
    Пример использования debounce:

    const debounceScroll = debounce(() => {
        do stuff...
    }, 100);

    App.W.on('scroll', () => {
        debounceScroll();
    });
*/

export function debounce(func, wait, immediate) {
    let timeout;

    return function() {
        let context = this, args = arguments;
        let later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};




/*
    Пример использования throttle:

    function throttleScroll() {
        do stuff...
    }

    App.W.on('scroll', throttle(throttleScroll, 100));
*/


export function throttle(callable, wait) {
    let id;

    function call(context, list) {
        requestAnimationFrame(function() {
            callable.apply(context, list);
            id = 0;
        });
    }

    return function() {
        if (id) return;
        id = setTimeout(call, wait, this, arguments);
    };
}




/*
    Получение GET-параметров из строки
*/

export function getUrlVars(href = window.location.href) {
    let hashes = href.slice(href.indexOf('?') + 1).split('&');
    let vars = [];
    let hash;

    for(let i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1] ? hash[1] : true;
    }
    return vars;
}

export function getUrlVar(name) {
    return getUrlVars()[name];
}

export function getHashVar() {
    return window.location.href.split('#')[1];
}

export function toggleText(element) {
    if (!element.data('alt')) return ;

    let current = element.text();
    let alt = element.data('alt');
    element.text(alt);
    element.data('alt', current);
}


/*
    Скролл страницы вверх независимо от истории браузера
*/

export function scrollTopForce() {
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }
}


export function scrollToElement(element) {
    if (!element || !element.length) return;
    let delta = App.mobile ? 115 : 250;

    //App.H.animate({'scrollTop': element.offset().top - delta});
    $('html, body').animate({'scrollTop': element.offset().top - delta});
}



/*
    Разбиение чисел на разряды (1000000 => 1 000 000)
*/

export function numberDivide(string) {
    if (string) {
        return string.toString().replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ');
    } else {
        return string;
    }
}




/*
    Склонение числительных
    Пример: declOfNum(count, ['комната', 'комнаты', 'комнат']);
*/

export function declOfNum(number, titles) {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
}





/*
    Случайное число от min до (max+1)
    Пример: randomInt(1, 3);
*/

export function randomInt(min, max) {
    let rand = min + Math.random() * (max + 1 - min);
    return Math.floor(rand);
}





/*
   Находится ли обьект в поле зрения
*/

export function isInViewport(elem) {
    const bounding = elem.getBoundingClientRect();

    return (
        bounding.top >= 0 &&
        //bounding.left >= 0 &&
        //bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
}

export function isInViewportArea(elem, area = 1) { // visiblePart = 1 видно 100% блока
    const bounding = elem.getBoundingClientRect();
    const wh = window.innerHeight || document.documentElement.clientHeight;

    if (bounding.top >= 0 && bounding.top < wh) {
        if (wh - bounding.top >= bounding.height * area) {
            return true;
        }
    } else if (bounding.bottom <= wh && bounding.bottom >=0) {
        if (wh - bounding.bottom >=  bounding.height * area) {
            return true;
        }
    }

    return false;
}


/*
 Не допускаем дробные пиксели в swiper(эффект замыливания)
 */
export function fixToIntPixel(wrapper) {
    if (wrapper.wrapperEl.style.transform.match(/\((.*?)px/) === null) {
        return false;
    }

    let shift = wrapper.wrapperEl.style.transform.match(/\((.*?)px/)[1];

    wrapper.wrapperEl.style.transform = wrapper.wrapperEl.style.transform.replace(/\((.*?)px/, '(' + parseInt(shift) + 'px');
}

export function loadLibrary(urls, callback) {
	const loadPromises = window.loadLibraryPromises = window.loadLibraryPromises || {};

	if (typeof urls == 'string') {
		if (!loadPromises[urls]) {
			loadPromises[urls] = new Promise(resolve => {
				load(urls, resolve);
			});
		}

		return loadPromises[urls]
			.then(() => callback());
	} else if (urls instanceof Array) {
		urls
			.filter(url => !loadPromises[url])
			.forEach(url => {
				loadPromises[url] = new Promise(resolve => {
					load(url, resolve);
				});
			});

		return Promise.all(urls.map(url => loadPromises[url]))
			.then(() => callback());
	}
	function load(url, resolve) {
		$.ajax({
			url: url,
			dataType: "script",
			cache: true,
			success: (data, textStatus, jqXHR) => {
				resolve();
			},
			error: (jqXHR, textStatus, errorThrown) => {
				console.log('loadLibrary', textStatus, url, errorThrown);
			}
		});
	}
}


/*
 Загрузка css файла
 */
export function loadCSS(urls, callback) {
    const loadPromises = window.loadCSSPromises = window.loadCSSPromises || {};

    if (typeof urls == 'string') {
        if (!loadPromises[urls]) {
            loadPromises[urls] = new Promise(resolve => {
                load(urls, resolve);
            });
        }

        return loadPromises[urls]
            .then(() => callback());
    } else if (urls instanceof Array) {
        urls
            .filter(url => !loadPromises[url])
            .forEach(url => {
                loadPromises[url] = new Promise(resolve => {
                    load(url, resolve);
                });
            });

        return Promise.all(urls.map(url => loadPromises[url]))
            .then(() => callback());
    }

    function load(href, resolve) {
        const head = document.getElementsByTagName('head')[0];
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = href;
        link.media = 'all';
        link.onload = resolve;
        head.appendChild(link);
    }
}

/*
 Определить подключен ли css файл из папки components по имени
 */
export function hasComponentStylesheet(name) {
    return Array.from(document.styleSheets).filter(stylesheet => stylesheet.href && stylesheet.href.indexOf(`/components/${name}.css`) !== -1).length > 0;
}
